import "react-app-polyfill/ie11";
import "webcrypto-shim";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import AppointmentForm from "./views/Appointment/AppointmentForm";
import { Auth0Provider } from "@bg/shared/lib/auth/react-auth0-wrapper";
import { SnackbarProvider } from "notistack";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import { getTenantConfig } from "./utils/tenantConfig";

// This is a public DSN and can be safely use in frontend code
Sentry.init({
  dsn: "https://218429f2bb2ec877cadc3469918969c3@o4509473453899776.ingest.us.sentry.io/4509473513472000",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

// ✅ Always call getTenantConfig() — it handles all logic
const config = getTenantConfig();

const cachedConfig =
  config || JSON.parse(localStorage.getItem("tenantConfig") || "{}");
const onRedirectCallback = (appState: any) => {
  // const cartItems: any = JSON.parse(localStorage.getItem("originalCart") || localStorage.getItem("cartTests") || "[]");

  // let additionalTests: string[] = [];
  // if (cartItems && cartItems.length > 0) {
  //   for (let i = 0; i < cartItems.length; i++) {
  //     const cartTestInfo = cartItems[i];
  //     additionalTests.push(
  //       `test=${cartTestInfo.testCode}${cartTestInfo.clientTestCode
  //         ? `&ctc=${cartTestInfo.clientTestCode}`
  //         : ""
  //       }`,
  //     );
  //   }
  // }

  // const hasCartTests = !!localStorage.getItem("cartTests");
  // const hasOriginalCart = !!localStorage.getItem("originalCart");

  // // Case 1: Cart exists → force redirect to create page
  // if (hasCartTests || hasOriginalCart) {
  //   document.location.replace(`${window.location.origin}/create?${additionalTests.join(",")}`);
  //   return;
  // }

  // Case 2: User was trying to access a protected route
  if (appState.targetUrl) {
    document.location.replace(appState.targetUrl.toString());
    return;
  }

  // Default fallback
  document.location.replace(window.location.origin);
};
const isAppointmentFormRoute =
  window.location.pathname === "/gc-appointment-form";
const Root = isAppointmentFormRoute ? (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
  >
    <AppointmentForm />
  </SnackbarProvider>
) : (
  <Auth0Provider
    domain={cachedConfig && cachedConfig.domain}
    client_id={cachedConfig && cachedConfig.client_id}
    audience={cachedConfig && cachedConfig.audience}
    redirect_uri={cachedConfig && cachedConfig.redirect_uri}
    onRedirectCallback={onRedirectCallback}
    leeway={cachedConfig && cachedConfig.leeway}
    scope={cachedConfig && cachedConfig.scope}
    cacheLocation="localstorage"
  >
    <App />
  </Auth0Provider>
);
ReactDOM.render(Root, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
